type Attachment = {
  id: string;
  name: string;
  mimeType: string;
};
export interface SearchEmailRequest {
  fields: string | null;
  limit: number | null;
  offset: number | null;
  order: string | null;
  filter: string | null;
  include: string | null;
}
export interface SearchEmailResponse {
  from: string;
  to: string;
  subject: string;
  id: string;
  sent?: string;
  createdAt?: string;
  status?:
    | 'bounce'
    | 'deferred'
    | 'delivered'
    | 'dropped'
    | 'open'
    | 'processed'
    | 'spamreport'
    | 'unsubscribed'
    | 'click';
  Attachments: Attachment[];
  Info: any;
  isResent?: boolean;
}

export enum direction_type {
  INBOUND = 'inbound',
  OUTBOUND = 'outbound'
}
